import React, { createContext, useState } from "react";
import { addDoc, arrayUnion, collection, doc, getDoc, getDocs, query, setDoc, Timestamp, updateDoc} from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { db } from '../firebase/config';

export const SetdataContext = createContext();

function SetdataProvider({children}){

    const [msj, setMsj] = useState([[""], [""], [""]])

    const [languageState, setLanguageState] = useState()

    const [sectionsState, setSectionsState] = useState([])

    const [data, setData] = useState([])

    const getSections = async (lang) => {
        let col

        if(lang === "ingles"){
            col = "proyects"
            
        } else if (lang === "español"){
            col = "proyectos"            
        }     
        
        const d = await getDocs(query(collection(db, col)));
        setData(d)
        let sec = []
        d.forEach((doc) => {
            console.log(doc.data().section);
            if(!sec.includes(doc.data().section)){
                sec.push(doc.data().section)
            }
        })
            
        console.log(sec);
        setSectionsState(sec)
    }
    
    const loadProyect = async (u) => {
        console.log("Recibido: ", u);
        console.log("Secciones: ", sectionsState);
        console.log("DATA: ", data);
        console.log(u.proyectName);
        let stref = []
        const imgs = document.getElementsByClassName("imgInput")
        const storage = getStorage()
        let auxMsj = msj

        for (let i = 0; i < imgs.length; i++) {
            let storeRef = ref(storage, (u.proyectName + "/" + imgs[i].files[0].name))
            
            try{
                await uploadBytes(storeRef, imgs[i].files[0])            
                .then((snapshot) => {
                    console.log(auxMsj);
                    auxMsj[0].push("Imagen " + i + " Cargada")
                    setMsj(auxMsj)
                    console.log(snapshot);
                })                    
            } catch(err){
                auxMsj[0] = err
                setMsj(auxMsj)
                console.log(err);
            }    
        }

        for (let i = 0; i < imgs.length; i++){
            try{
                await getDownloadURL(ref(storage,(u.proyectName + "/" + imgs[i].files[0].name)))
                .then((url) => {
                    auxMsj[1].push("URL " + i + " Obtenido")
                    setMsj(auxMsj)
                    stref.push(url)
                })
            } catch(err){
                auxMsj[1] = err
                setMsj(auxMsj)
                console.log(err);
            }  
        }      

        let col

        if(u.language === "ingles"){
            col = "projects"

        } else if(u.language === "español"){
            col = "proyectos"            
        }

        try{
            await setDoc(doc(db, col, u.proyectName), {
                timestamp: Timestamp.fromDate(new Date()),
                section: u.sectionName,
                sectionID: u.sectionID,
                nameID: u.nameID,
                data: {
                        shortDesc: u.proyectShortDesc,
                        longDesc: u.proyectLongDesc,
                        imagesURL: stref,
                        imgDesc: JSON.parse(u.proyectImgDesc),
                        order: u.sectionOrden,
                        rol: u.proyectRol,
                        task: JSON.parse(u.proyectTasks),
                        coworkers: JSON.parse(u.proyectCoworkers),
                        link: u.proyectLink
                }
            })
            .then((snapshot) => {
                auxMsj[2].push("Formulario cargado.")
                setMsj(auxMsj)
                console.log(snapshot);
            })
        } catch(err){
            auxMsj[1] = err
            setMsj(auxMsj)
            console.log(err);
        }
    }

    const loadResume = async (u) => {
        console.log(u);
        let col

        if(u.lang === "ingles"){
            col = "resume"

        } else if (u.lang === "español"){
            col = "curriculum"
        }

        try{
            await updateDoc(doc(db, col, u.section), {
                items: arrayUnion({
                                    ...u.object,
                                    timestamp: Timestamp.fromDate(new Date())
                                }
                )
            })
            .then((snapshot) => {
                console.log(snapshot);
            })
        } catch(err){
            console.log(err);
        }
    } 

    const login = async (u) => {
        const d = await getDocs(query(collection(db, "users")));
        d.forEach((doc) => {
            console.log(doc.data());
            if(doc.data().user === u.ser && doc.data().pass === u.pass){
                return true
            }
        })

        return false
    }

    return(
        <SetdataContext.Provider value={{
            sectionsState,
            msj,
            loadProyect,
            loadResume,
            getSections,
            login,
        }}>
            {children}
        </SetdataContext.Provider>
    )
}

export default SetdataProvider
